module.exports = __webpack_public_path__ + "static/media/Parc5-3.46ae20b0.jpg";